import { clientLocalDate } from './clientContext'

const STORAGE_PREFIX = 'kilo_morning_checkin_session'

export type MorningCheckInSessionRecord = {
  completedAt: string
}

function storageKey(dateId = clientLocalDate()): string {
  return `${STORAGE_PREFIX}:${dateId}`
}

export function readMorningCheckInSession(dateId = clientLocalDate()): MorningCheckInSessionRecord | null {
  try {
    const raw = sessionStorage.getItem(storageKey(dateId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as MorningCheckInSessionRecord
    if (typeof parsed.completedAt !== 'string') return null
    return parsed
  } catch {
    return null
  }
}

export function markMorningCheckInSessionComplete(at = new Date()): MorningCheckInSessionRecord {
  const record: MorningCheckInSessionRecord = { completedAt: at.toISOString() }
  try {
    sessionStorage.setItem(storageKey(), JSON.stringify(record))
  } catch {
    /* sessionStorage unavailable */
  }
  return record
}

export function isMorningCheckInCompletedThisSession(dateId = clientLocalDate()): boolean {
  return readMorningCheckInSession(dateId) != null
}
